import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/Index.vue';
import Pulseras from './views/pulseras.vue';
import Entradas from './views/entradas.vue';

Vue.use(Router)

export const router = new Router({
    base: process.env.VUE_APP_API_PRINCIPAL,
    routes: [
        {
            path: "/",
            name: "index",
            meta: {

                title: 'DISEÑA'
            },
            component: Index,

        },
        {
            path: '/pulseras',
            name: 'pulseras',
            meta: {

                title: 'DISEÑA TU PULSERA'
            },
            component: Pulseras,

        },
        {
            path: '/entradas',
            name: 'entradas',
            meta: {

                title: 'DISEÑA TU ENTRADA'
            },
            component: Entradas,

        },
    ],
    mode: 'history'
});

